module.exports = __webpack_public_path__ + "img/inter_sprint_logo.58e2605d.png";